/// <reference path="../../../typings/augmentedTypes.d.ts" />
"use strict";
// TODO should we use Autoprefixer?
// https://github.com/postcss/autoprefixer
//
// basarat doesn't like automatically adding vendor prefixes:
// https://github.com/typestyle/typestyle/issues/73#issuecomment-267715985
//
// Radium does do vendor prefixes:
// https://github.com/FormidableLabs/radium/blob/master/docs/comparison/README.md
var typestyle_1 = require("typestyle");
exports.Annotation = typestyle_1.style({
    fontFamily: 'Helvetica Neue, Helvetica, sans-serif',
    display: 'inline-block',
    position: 'absolute',
    right: '75px',
    top: '100px',
    verticalAlign: 'text-top',
    textAlign: 'center',
    margin: 0,
    zoom: 1,
    // TODO what about other browsers?
    '-webkit-font-smoothing': 'antialiased',
    background: '#F9F9F9',
    width: '260px',
    borderRadius: '10px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.3),inset 0 1px 1px rgba(255,255,255,0.8)',
    // TODO are these prefixes still needed?
    '-webkit-box-shadow': '0 1px 3px rgba(0,0,0,0.3),inset 0 1px 1px rgba(255,255,255,0.8)',
    '-moz-box-shadow': '0 1px 3px rgba(0,0,0,0.3),inset 0 1px 1px rgba(255,255,255,0.8)',
    padding: '10px 5px 0 5px',
    zIndex: 999999,
});
exports.HeaderText = typestyle_1.style({
    fontSize: '22px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    color: '#333',
    letterSpacing: '.8px',
    textAlign: 'center',
});
exports.Close = typestyle_1.style({
    float: 'right',
    padding: '0 5px 0 0',
    color: '#aaa',
    $nest: {
        '&:hover': {
            cursor: 'pointer',
        }
    }
});
exports.Description = typestyle_1.style((_a = {
        textAlign: 'center',
        margin: '0 0 0 auto',
        fontSize: '14px',
        fontStyle: 'italic'
    },
    _a["h2"] = {
        fontWeight: 'normal',
        fontVariant: 'normal',
        fontStyle: 'italic',
        lineHeight: '1.5',
        fontSize: '14px',
        color: '#696969',
        display: 'inline-block',
        padding: '0',
        margin: '0',
        border: '0',
        zoom: 1,
    },
    _a));
exports.AnnotationItemsContainer = typestyle_1.style((_b = {
        $nest: {
            '& ::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
                borderRadius: '10px',
            },
            '& ::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.5)',
            },
            '& ::-webkit-scrollbar': {
                width: '12px',
            },
        }
    },
    _b["ul"] = {
        lineHeight: '120%',
        listStyle: 'none',
        textAlign: 'left',
        padding: '0 0 0 10px',
        margin: '5px -5px 10px -5px',
        maxHeight: '300px',
        minHeight: '30px',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    _b));
exports.AnnotationItem = typestyle_1.style((_c = {},
    _c["li"] = {
        padding: '0px',
        display: 'block',
        margin: '0 auto 0 auto',
    },
    _c));
exports.AnnotationItemTitle = typestyle_1.style({
    color: '#696969',
    display: 'inline',
    fontSize: '10pt',
    fontWeight: 'bold',
    margin: '0 auto 0 auto',
    padding: '0px',
});
exports.AnnotationItemText = typestyle_1.style({
    padding: '0px',
    display: 'inline',
    margin: '0 5px 0 auto',
    fontSize: '9pt',
    textDecoration: 'none',
});
exports.AnnotationItemLinkText = typestyle_1.style({
    color: 'blue',
    display: 'inline',
    fontSize: '9pt',
    margin: '0 5px 0 auto',
    padding: '0px',
    textDecoration: 'none',
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
});
var _a, _b, _c;
/* I don't think these are being used:
export const Move = style({
    float: 'left',
    padding: '0',
    color: '#aaa',
    fontSize: '80%',
    $nest: {
        '&:hover': {
            cursor: 'move',
        }
    }
});

export const Search = style({
    verticalAlign: '10%',
    textDecoration: 'none', // tweak needed for wp
    //font-size: 60%, // tweak that was maybe needed for wp?
    $nest: {
        '&:hover': {
            cursor: 'pointer',
        }
    }
});

export const Tooltip = style({
  fontSize: '8pt',
});
//*/
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/components/XrefsAnnotationPanel/styles.style.js
// module id = 245
// module chunks = 0